import { render, staticRenderFns } from "./sessionview.vue?vue&type=template&id=3bbb72db&"
import script from "./sessionview.vue?vue&type=script&lang=ts&"
export * from "./sessionview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbb72db')) {
      api.createRecord('3bbb72db', component.options)
    } else {
      api.reload('3bbb72db', component.options)
    }
    module.hot.accept("./sessionview.vue?vue&type=template&id=3bbb72db&", function () {
      api.rerender('3bbb72db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sessionview.vue"
export default component.exports